var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-height":"75vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"yellow","indeterminate":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }